import { ConfigFn } from '@config/types'

const config = (({ deploymentEnv }) => {
  const scriptBaseUrl =
    deploymentEnv === 'prod'
      ? 'https://api.tiun.live/live_api/v2/snippets/PW0m6li8LwrqCH8lf3jH5KsK4wm2FO7W3rTw82MJ'
      : 'https://api-staging.tiun.live/live_api/v2/snippets/P4Ziliqgzne5AXye4XHd7Qal4zuBcVKtINgQLyp0'
  const snippetCSSBaseUrl =
    deploymentEnv === 'prod'
      ? 'https://api.tiun.live/live_api/v2/snippets/PW0m6li8LwrqCH8lf3jH5KsK4wm2FO7W3rTw82MJ'
      : 'https://api-staging.tiun.live/live_api/v2/snippets/P4Ziliqgzne5AXye4XHd7Qal4zuBcVKtINgQLyp0'
  return {
    scriptUrl: `${scriptBaseUrl}/background_js?appearance=light&language=de&corners=rounded&style=KysrySsr1NTU1NTUudTn`,
    snippetCSSUrl: `${snippetCSSBaseUrl}/background_css`,
    faqUrl:
      'https://faq.blick.ch/s/article/Wie-funktioniert-die-Option-Ohne-Abo-lesen?language=de',
  } as const
}) satisfies ConfigFn
export default config
